import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SAFETY_RECOMMENDATIONS_ROUTE, NOT_FOUND_ROUTE, UNDER_MAINTENANCE } from '@core/app.constants';
import { NotFoundComponent } from '@core/components/not-found/not-found.component';
import { UnderMaintenanceComponent } from '@core//components/under-maintenance/under-maintenance.component';
const routes: Routes = [
  {
    path: SAFETY_RECOMMENDATIONS_ROUTE,
    loadChildren: () => import('./features/safety-recommendations/safety-recommendations.module')
      .then(m => m.SafetyRecommendationsModule)
  },
  {
    path: '',
    redirectTo: '/' + SAFETY_RECOMMENDATIONS_ROUTE,
    pathMatch: 'full'
  },
  {
    path: NOT_FOUND_ROUTE,
    component: NotFoundComponent
  },
  {
    path: '*',
    component: NotFoundComponent
  },
  {
    path: UNDER_MAINTENANCE,
    component: UnderMaintenanceComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
